import React from 'react'

import {ENTITY_SELECTOR_SEARCH_HEIGHT} from "../selector"

type Props = {
    children?: any
}

const debug = false
// const debug = "EntitySelectorSearchRow"

export default function EntitySelectorSearchRow (props:Props) {
    const styles = {
        height: ENTITY_SELECTOR_SEARCH_HEIGHT
    }

    return (
        <div className="entity-selector-search flex-row-left-center fl-sb flex-no-shrink p-l-15 p-t-15 p-r-15 p-b-10" style={styles}>
            {props.children}
        </div>
    )
}
